import React from 'react';

const PaginationItems = ({ totalPages, lastPage, currentPage, changePage }) => {
    let pages = [];

    let maxPagiBox = 10
    let totalLoop = currentPage + maxPagiBox - currentPage % maxPagiBox
    let start = totalLoop - maxPagiBox <= 0 ? 1 : totalLoop - maxPagiBox

    if (lastPage < maxPagiBox) {
        totalLoop = lastPage
    }

    if (totalLoop >= totalPages) {
        totalLoop = totalPages
    }

    for(let i = start; i <= totalLoop; i++) {
        let item = (
            <li key={i} className={i === currentPage ? 'active page-item' : 'page-item'}>
                <a className="page-link" href="#page" onClick={() => changePage(i)}>{i}</a>
            </li>
        );

        pages.push(item);
    }

    return pages;
}

const Pagination = ({ data, changePage }) => {

    function switchPage(page) {
        if ( page >= data.last_page ) {
            page = data.last_page;
        }

        if ( page < 1 ) {
            page = 1;
        }

        changePage(page);
    }

    return (
        <nav>
            <ul className="pagination">
                <li className="page-item">
                    <a className="page-link" href="#prev" onClick={() => switchPage(data.current_page - 1)}>Previous</a>
                </li>

                <PaginationItems
                    totalPages={data.total}
                    lastPage={data.last_page}
                    currentPage={data.current_page}
                    changePage={switchPage}
                />

                <li className="page-item">
                    <a className="page-link" href="#next" onClick={() => switchPage(data.current_page + 1)}>Next</a>
                </li>
            </ul>
        </nav>
    )
}

export default Pagination;